import React, { useState } from "react";
import Head from "next/head";
import FeaturedBlogs from "../../../components/VLSI/featuredBlogs";
import Menu from "../../../components/VLSI/menu";
import MobileMenu from "../../../components/VLSI/mobileMenu";
import Modal from "../../../components/VLSI/modal";
import { redirectTo500 } from "../../../utils/utility";
import ghost from "../../../utils/ghost";
import Footer from "../../../components/VLSI/footer";
import MobileFooter from "../../../components/VLSI/mobileFooter";

export async function getStaticProps(context) {
  const featuredData = await ghost({
    filter: "tags:blog" + "+tags:vlsi",
    pagination: { limit: 3 },
  });
  const listPagedData = await ghost({
    filter: "tags:blog" + "+featured:false",
    pagination: { limit: "all" },
  });

  if (!featuredData || !listPagedData) {
    return redirectTo500();
  }
  return {
    props: {
      featured: featuredData,
      listData: listPagedData,
    },
    revalidate: 3600,
  };
}

const Infrastructure = (props) => {
  // modal state
  const [showModal, setShowModal] = useState(false);
  const handleOnClose = () => setShowModal(false);
  return (
    <div>
      <Head>
        <title>Infrastructure | Harware Solution in Bangladesh</title>
        <meta
          name="description"
          content="DSi blog space covers the latest technologies and industry trends in eloquent articles penned by our seasoned tech enthusiasts."
        />
      </Head>
      <div className="negative-margin sticky top-0 z-50">
        <header className="hidden lg:block w-full bg-black sticky top-0 z-50">
          <Menu />
        </header>
        <header className="block lg:hidden w-full bg-black sticky top-0 z-50">
          <MobileMenu />
        </header>
      </div>

      {/* page content container */}
      {/* Hero section */}

      <section className="bg-gray-100">
        <div className="flex flex-col gap-3 lg:gap-6 max-w-screen-xl mx-auto items-center p-7 lg:py-24 lg:px-[30px]">
          <div className=" text-2xl sm:text-4xl lg:text-6xl text-gray-900 font-bold sm:font-black">
            Infrastructure
          </div>
          <div className="lg:text-xl text-gray-500 lg:leading-relaxed text-center max-w-3xl mx-auto">
            Explore our innovative infrastructure solutions at DSi. We
            specialize in building secure, high-performance, and scalable
            environments. Join us to experience the future of infrastructure.
          </div>
          <div className=" mt-2 flex gap-4">
            <button
              onClick={() => {
                setShowModal(true);
              }}
              className=" inline-flex items-center gap-2 px-5 py-3 bg-[#1A56DB] hover:bg-blue-800 text-white  "
            >
              Contact Us <img src="/images/VLSI/ic/arrow-right.svg" />
            </button>
            <a
              href="#second_section_INF"
              className=" inline-flex px-5 py-3 bg-gray-50 hover:bg-gray-100  border border-gray-200 "
            >
              Learn More
            </a>
          </div>
        </div>
      </section>
      {/* modal */}
      <Modal visible={showModal} onClose={handleOnClose} />
      {/* modal ENDS */}
      {/* Hero section ENDS */}

      {/* 2nd section DSi Package Flow */}
      <section className="bg-gray-50" id="second_section_INF">
        <div className="flex flex-col lg:gap-6 max-w-screen-xl mx-auto items-center p-7 lg:pt-24 lg:pb-16 lg:px-[30px]">
          <div class=" text-xl lg:text-4xl text-gray-900 font-bold sm:font-black">
            DSi Package Flow
          </div>
          <div className="lg:text-xl text-gray-500 lg:leading-relaxed text-center max-w-3xl mx-auto">
            We believe in thoroughness and precision at each stage of our
            package flow, ensuring your semiconductor devices are handled with
            care and expertise
          </div>
        </div>

        {/* Cards container */}
        <div className="max-w-screen-xl mx-auto p-7 lg:px-[30px] lg:pb-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-8">
            {/* card 1 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/infrastructure/Securing Your Digital Oasis.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                  Securing Your Digital Oasis
                </span>
                <p className="mt-2 sm:leading-relaxed text-gray-500">
                We ensure your data and processes are protected against threats by building a secured and protected High-Performance Computing (HPC)
                </p>
              </div>
            </div>
            {/* card 2 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/infrastructure/Toolchain Management.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                Toolchain Management
                </span>
                <p className="mt-2 sm:leading-relaxed text-gray-500">
                Say goodbye to toolchain chaos. We manage your tools seamlessly, so you can focus on what truly matters – innovation.
                </p>
              </div>
            </div>

            {/* card 3 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/infrastructure/Unleash Scalability.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                Unleash Scalability
                </span>
                <p className="mt-2 sm:leading-relaxed text-gray-500">
                Growth should never be a limitation. Our scalable infrastructure expands as you do, adapting to your evolving needs without a hitch.
                </p>
              </div>
            </div>

            {/* card 4 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/infrastructure/Mastering Cost Efficiency.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                Mastering Cost Efficiency
                </span>
                <p className="mt-2 sm:leading-relaxed text-gray-500">
                We've cracked the code on cost management. Enjoy high-quality infrastructure without breaking the bank.
                </p>
              </div>
            </div>

            {/* card 5 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/infrastructure/Streamline.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                Streamlined CI/CD
                </span>
                <p className="mt-2 sm:leading-relaxed text-gray-500">
                Experience a frictionless development pipeline with our Continuous Integration and Continuous Deployment (CI/CD) solutions.
                </p>
              </div>
            </div>

            {/* card 6 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/infrastructure/Always in Control.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                Always in Control
                </span>
                <p className="mt-2 sm:leading-relaxed text-gray-500">
                Our administration and monitoring systems ensure peak performance and health, so you can stay focused on your goals.
                </p>
              </div>
            </div>

            {/* card 7 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/infrastructure/Access.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                Access, Tailored
                </span>
                <p className="mt-2 sm:leading-relaxed text-gray-500">
                Role-based access control ensures that everyone has precisely the permissions they need – no more, no less.
                </p>
              </div>
            </div>

            {/* card 8 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/infrastructure/License.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                Licensing, Simplified
                </span>
                <p className="mt-2 sm:leading-relaxed text-gray-500">
                Email us for general queries, including marketing and partnership opportunities.
                </p>
              </div>
            </div>

            {/* card 9 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/infrastructure/Cloud.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                FPGA in the Cloud
                </span>
                <p className="mt-2 sm:leading-relaxed text-gray-500">
                Seamlessly integrate FPGAs into your cloud environment, opening up new possibilities for your projects.
                </p>
              </div>
            </div>

            {/* card 10 */}
            <div className="flex flex-col py-9 lg:py-12 px-6 lg:px-9 gap-4 border border-gray-300 bg-gray-100 h-70 xl:h-80">
              <img
                src="/images/VLSI/infrastructure/world_connectivity.png"
                className="w-16 h-16"
              />
              <div>
                <span className=" text-xl font-bold text-gray-900">
                Worldwide Connectivity
                </span>
                <p className="mt-2 sm:leading-relaxed text-gray-500 line-clamp-3">
                Our interconnected systems span across regions and the globe, ensuring your operations run smoothly, no matter where you are.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Cards container ENDS */}
      </section>
      {/* 2nd section DSi Package Flow ENDS */}
      {/* 3rd section Tools we use */}
      <section className="bg-gray-100">
        <div className=" max-w-screen-xl mx-auto p-7 lg:py-24 lg:px-[30px]">
          <div className="text-center text-2xl sm:text-4xl text-gray-900 font-bold mb-6 sm:mb-12 ">
            Tools we use
            <p className="mt-2 sm:mt-4 text-base sm:text-xl lg:leading-relaxed text-gray-500 font-normal max-w-3xl mx-auto">
            Cutting-edge Technologies and Powerful Tools for Innovative Solutions and Efficient Development.
            </p>
          </div>
          {/* tools list */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8 lg:gap-16">
            {/* icon 1 */}
            <div className="flex flex-col justify-center items-center mt-7">
              <img
                src="/images/VLSI/infrastructure/aws_icon.svg"
                className=" w-20 h-12"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Amazon Web Services
              </p>
            </div>
            {/* icon 2 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/jenkins_icon.svg"
                className=" w-14 h-20"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Jenkins
              </p>
            </div>
            {/* icon 3 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/gitlab_icon.svg"
                className=" w-16 h-16"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Gitlab
              </p>
            </div>
            {/* icon 4 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/github_icon.svg"
                className=" w-16 h-16"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Github
              </p>
            </div>

            {/* icon 5 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/kubernetes_icon.svg"
                className=" w-16 h-16"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Kubernetes
              </p>
            </div>
            {/* icon 6 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/serverless_architecture_icon.svg"
                className=" w-16 h-16"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Serverless architecture
              </p>
            </div>
            {/* icon 7 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/terraform_icon.svg"
                className=" w-16 h-16"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Terraform
              </p>
            </div>
            {/* icon 8 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/cloud_formation.svg"
                className=" w-20 h-12"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Cloud formation
              </p>
            </div>

            {/* icon 9 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/ansible_icon.svg"
                className=" w-16 h-16"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Ansible
              </p>
            </div>
            {/* icon 10 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/shell_icon.svg"
                className=" w-20 h-20"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Shell (bash, csh)
              </p>
            </div>
            {/* icon 11 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/perl_icon.svg"
                className=" w-20 h-20"
              />
              <p className="text-gray-500 ml-4 text-center text-xs sm:text-base">
                Perl
              </p>
            </div>
            {/* icon 12 */}
            <div className="flex flex-col justify-center items-center">
              <img
                src="/images/VLSI/infrastructure/python_icon.svg"
                className=" w-20 h-20"
              />
              <p className="text-gray-500 text-center text-xs sm:text-base">
                Python
              </p>
            </div>
          </div>
          {/* tools list ENDS */}
        </div>
      </section>
      {/* 3rd section Tools we use ENDS */}
      {/* page content container ENDS */}

      {/* featured */}
      <div className="bg-gray-50 w-full py-10 sm:py-20">
        <div className="grid mid-home-column">
          <div className="pb-12 items-center flex flex-col">
            <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
              Read what we wrote
            </h2>
            <p className="text-center flex font-headline items-center text-base md:text-xl leading-8 text-gray-600">
              Get front-row industry insights
            </p>
          </div>
          <div className="flex justify-center mx-5">
            <FeaturedBlogs
              how={props.featured.posts}
              path="/blogs/"
              title="VIEW DETAILS"
            />
          </div>
        </div>
      </div>

      {/* {showModal && <Modal />} */}
      <div className="hidden md:block md:footer-div absolute z-50 bg-black md:py-24 w-full px-10 xl:px-32">
        <Footer />
      </div>
      <div className="block md:hidden absolute z-50 bg-black py-10 w-full px-7">
        <MobileFooter />
      </div>
    </div>
  );
};

export default Infrastructure;
